import {Backbone} from 'Vertebrae';
import {Location} from '../model/location';

export const Locations = Backbone.Collection.extend({
    _name: 'Locations',
    model: Location,
});
